import Quill from "quill/core";
import Toolbar from "quill/modules/toolbar";
import {ImageDrop} from "quill-image-drop-module";
import Snow from "quill/themes/snow";
import Header from "quill/formats/header";
import Bold from "quill/formats/bold";
import Italic from "quill/formats/italic";
import Strike from "quill/formats/strike";
import Underline from "quill/formats/underline";
import Link from "quill/formats/link";
import Blockquote from "quill/formats/blockquote";
import Code from "quill/formats/code";
import Image from "quill/formats/image";

/**********************
 * IRIS onLoad events *
 **********************/

iris.onloadEvents = function() {
    /******************************/
    /* initialise vendor plug-ins */
    /******************************/

    // popper (tooltips)
    $('[data-toggle="tooltip"]').tooltip();

    // dropify
    window.dropify = $('.dropify').dropify();
    window.dropify.on('dropify.afterClear', function (event, element) {
        // if a brand logo was removed (in the profile branding section), add it to the removedLogos array
        if ($.inArray(this.id, ['whitelogo', 'blacklogo', 'colorlogo']) >= 0) {
            iris.removedLogos.push($(event.target).attr('name'));
        }
    });

    // jquery-ui datepicker
    $('.datepicker').datepicker({dateFormat: "dd-mm-yy"});

    // multiselect (e.g. used for selecting roles)
    $('.moduleRoles').multiSelect({
        selectableHeader: '<div class="selectableHeader">Unassigned Roles</div>',
        selectionHeader: '<div class="selectionHeader">Assigned Roles</div>'
    });

    // colorpicker
    $('#primaryColor').colorpicker({format: 'hex'});
    $('#secondaryColor').colorpicker({format: 'hex'});

    // init bootstrap toggle that's used on the preferences tab
    $('.preference').bootstrapToggle();

    // init infinite scroll helper for tickets
    $('#ticketListingContainer').infiniteScrollHelper({
        loadMore: function (page, done) {
            $('.pagination.more-items a').text('Loading more...');
            let nextPageUrl = $('.pagination a:last-child').attr('href');

            if (nextPageUrl === '#') {
                done();
                return;
            }

            $.get(nextPageUrl, {partial: true}, function (data) {
                $('.pagination').remove();
                $(data).appendTo('#ticketListingContainer');
                done();
            });
        }
    });

    // quill editor
    Quill.register({
        'modules/toolbar': Toolbar,
        'modules/imageDrop': ImageDrop,
        'themes/snow': Snow,
        'formats/header': Header,
        'formats/bold': Bold,
        'formats/italic': Italic,
        'formats/strike': Strike,
        'formats/underline': Underline,
        'formats/link': Link,
        'formats/blockquote': Blockquote,
        'formats/code': Code,
        'formats/image': Image
    });

    // Animated counter
    $('.counter').each(function () {
        const $this = $(this);
        const countTo = $this.attr('data-count');

        $({countNum: $this.text()}).animate({
                countNum: countTo
            },
            {
                duration: 800,
                easing: 'linear',
                step: function () {
                    $this.text(Math.floor(this.countNum));
                },
                complete: function () {
                    $this.text(this.countNum);
                }
            });
    });

    // init countTo that's used on the tickets tab
    var $countTos = $('[data-toggle="count-to"]').countTo();

    // generate example invoice URL's for billing APIs
    profile.generateInvoicesUrls();
    profile.generateCustomersUrls();

    // init variables
    iris.usernameChangedManually = false;
    iris.removedLogos = [];

    // Close dropdowns on body click or mouseleave
    $('body')
        .on('mouseenter mouseleave', '.dropdown', iris.toggleDropdown)
        .on('click', '.dropdown-menu a', iris.toggleDropdown);

    iris.security();
    iris.polyfills();
    iris.ajaxConfigure();
}

/***************
* IRIS Methods *
****************/

iris.behaviors = {};

iris.loader = $('<div id="loading-wrapper"><div id="loading"><i class="fa fa-spinner icon-4x fa-spin text-primary"></i><span class="sr-only">Loading...</span></div></div>');

iris.reloadWindow = function () {
    window.location.reload(true);
};

iris.parseQuery = function (qstr) {
    var query = {};
    var a = (qstr[0] === '?' ? qstr.substr(1) : qstr).split('&');
    for (var i = 0; i < a.length; i++) {
        var b = a[i].split('=');
        query[decodeURIComponent(b[0])] = decodeURIComponent(b[1] || '');
    }
    delete query[""]; //cleanup
    return query;
};

iris.appendToUrl = function (name, value) {
    var queries = iris.parseQuery(window.location.search);
    queries[name] = value;

    return queries;
};

// Make dropdowns work on hover state
iris.toggleDropdown = function (e) {
    const _d = $(e.target).closest('.dropdown');
    const _m = $('.dropdown-menu', _d);

    setTimeout(function () {
        const shouldOpen = e.type !== 'click' && _d.is(':hover');
        _m.toggleClass('show', shouldOpen);
        _d.toggleClass('show', shouldOpen);
        $('[data-toggle="dropdown"]', _d).attr('aria-expanded', shouldOpen);
    }, e.type === 'mouseleave' ? 500 : 0);
}

iris.setButtonLoading = function (element) {
    element.prop('disabled', true);
    element.addClass('loading');
}

iris.unsetButtonLoading = function (element) {
    element.removeClass('loading');
    element.prop('disabled', false);
}

iris.setButtonLoadingByReference = function(buttonRef) {
    let button = $('body').find(buttonRef);

    iris.setButtonLoading(button);
}

iris.unsetButtonLoadingByReference = function(buttonRef) {
    let button = $('body').find(buttonRef);

    iris.unsetButtonLoading(button);
}

iris.getDate = function (element) {
    let date;
    try {
        date = $.datepicker.parseDate('dd-mm-yy', element.value);
    } catch (error) {
        date = null;
    }

    return date;
}

/**
 * Integration for the default IRIS media manager
 */
iris.mediamanager = function (options, cb) {
    var route_prefix = (options && options.prefix) ? options.prefix : '/laravel-filemanager';
    window.open(route_prefix + '?type=' + options.type || 'file', 'FileManager', 'width=900,height=600');
    window.SetUrl = cb;
};

iris.defaultMddConfiguration = {
    disableTabHandling: true,
    resizebar: false,
    help_location: "https://confluence.copaco.com/display/PP/Writing+Knowledgebase+articles+in+IRIS",
    media_callback: function () {
        iris.mediamanager({type: 'file'}, function (url, path) {
        })
    },
    image_callback: function (cb) {
        iris.mediamanager({type: 'image'}, cb);
    },
};

iris.polyfills = function () {
    $('button[form]').click(function () {
        $('#' + this.getAttribute('form')).submit();
    });
};

iris.security = function (topFilter) {
    var magicToken = $('meta[name="csrf-token"]').attr('content'); //$("input[name=_token]").first();
    if (!magicToken) {
        return;
    } // no sense in continuing if form POSTS will fail
    function getConfirmText(item) {
        var dText = item.data('confirmText') || item.data('confirmtext');
        if (dText === undefined) {
            dText = item.attr('confirmText');
        }
        return dText;
    }

    var buffer = $('<div/>"');

    var selector = $("a[itemprop~=UnsafeUrl],button[itemprop~=UnsafeUrl]");
    if (topFilter) {
        selector = $(topFilter).find("a[itemprop~=UnsafeUrl],button[itemprop~=UnsafeUrl]");
    }

    selector.each(function () {
        var _this = $(this);
        var hrefParts = _this.attr("href").split("?");
        var form = $("<form action=\"" + hrefParts[0] + "\" method=\"POST\" />");
        form.append($('<input name="_token" value="' + magicToken + '" type="hidden">'));
        if (hrefParts.length > 1) {
            var queryParts = hrefParts[1].split("&");
            for (var i = 0; i < queryParts.length; i++) {
                var queryPartKVP = queryParts[i].split("=");
                //trusting hrefs in the page here
                form.append($("<input type=\"hidden\" name=\"" + decodeURIComponent(queryPartKVP[0]) + "\" value=\"" + decodeURIComponent(queryPartKVP[1]) + "\" />"));
            }
        }
        form.css({"position": "absolute", "left": "-9999em"});
        buffer.append(form); //we use a buffer here to reduce DOM churn and redraws
        _this.click(function () {
            if (getConfirmText(_this) !== undefined) {
                //we use bootbox for a better UI experience, but could very well be a simple js confirm
                bootbox.confirm(getConfirmText(_this), function (confirmed) {
                    if (confirmed)
                        form.submit();
                });
            } else {
                form.submit();
            }
            return false;
        });
    });
    $("body").append(buffer.children());
};

iris.ajaxConfigure = function () {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            'cache': false
        }
    });
};

iris.behaviors.CascadingDropDownBehavior = function (options) {
    var settings = $.extend({
        parentplaceholder: "Select your value",
        childplaceholder: "Select your value",
        parentUrl: '',
        childUrl: '',
        childUrlFilterParam: 'filter'
    }, options);

    let parentControl = $(settings.parentControl);
    let childControl = $(settings.childControl);

    var initChildControl = function (id) {
        var baseUrl = settings.childUrl;

        if (id.length === 0) {
            childControl.ajaxDropdown({
                url: baseUrl,
                placeholder: settings.childplaceholder,
                minimumInputLength: 0
            });
        } else {
            childControl.ajaxDropdown({
                url: baseUrl + "?" + settings.childUrlFilterParam + "=" + id,
                placeholder: settings.childplaceholder,
                minimumInputLength: 0
            });
        }
    };

    parentControl.ajaxDropdown({
        url: settings.parentUrl,
        placeholder: settings.parentplaceholder,
        minimumInputLength: 0
    }).on('change', function (e) {
        childControl.select2('destroy');
        if (e.val.length !== 0) {
            initChildControl(e.val);
        } else {
            initChildControl('');
        }
    });

    initChildControl(parentControl.val());
};

iris.logAndAlert = function(response, status, error, message = 'Failed to complete your request, please try again', divId = '#ajax-validation') {
    console.log("AJAX error: " + status + " (" + response.status + ") : " + error);

    $(divId).html('<div>' + message + '</div>');
    $(divId).removeClass('alert-success');
    $(divId).addClass('alert-danger');
    $(divId).show();
}